/**
 * @file WriteoffActPrintButton.tsx
 * @description Кнопка «Печать акта» в шапке проведённого списания
 * (phase19.23 этап A).
 *
 * Акт — первичный документ по списанию (брак, просрочка, потеря), его подшивают
 * к отчётности. Сервер отдаёт PDF только по проведённому документу (409
 * `writeoff_not_committed`), поэтому кнопку показываем тоже только там.
 *
 * Обвязка та же, что у листа комплектации: скачать blob → `saveBlob` →
 * человеческая ошибка тостом.
 */

import { Loader2, Printer } from "lucide-react";
import { useState } from "react";

import { Button } from "../ui/button";
import { useNotify } from "../ui/NotifyProvider";
import { writeoffsApi } from "../../lib/api-wms";
import { saveBlob } from "../../lib/download";
import { wmsErrorText } from "../../lib/wms-error-text";

interface Props {
  writeoffId: string;
  /** Номер документа — попадает в имя файла. */
  number: string;
}

export function WriteoffActPrintButton({ writeoffId, number }: Props) {
  const notify = useNotify();
  const [printing, setPrinting] = useState(false);

  async function handlePrint() {
    setPrinting(true);
    try {
      const file = await writeoffsApi.printAct(writeoffId, number);
      saveBlob(file.blob, file.filename);
    } catch (err) {
      notify.error(wmsErrorText(err, "Не удалось получить акт списания"));
    } finally {
      setPrinting(false);
    }
  }

  return (
    <Button
      variant="outline"
      disabled={printing}
      onClick={() => void handlePrint()}
    >
      {printing ? (
        <Loader2 className="size-4 animate-spin" />
      ) : (
        <Printer className="size-4" />
      )}
      <span className="ml-2">{printing ? "Готовим акт…" : "Печать акта"}</span>
    </Button>
  );
}
